import { useAction } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'
import { unsafeUrlDialogEvent } from '@root/entities/deeplinking/unsafe-url-dialog'
import { StringUtil } from '@root/shared'
import { SearchLoupeIcon } from '@root/shared/ui-kit'

import type { CurrencyAddress } from '@root/entities/currency'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  currencyAddress: CurrencyAddress
  size?: number
  symbol: string | undefined
} & ClassNameProps

const XUrl = new URL('https://x.com/')

const createXSearchUrl = (args: {
  currencyAddress: CurrencyAddress
  symbol: string | undefined
}) => {
  const searchUrl = new URL('/search', XUrl)
  searchUrl.searchParams.set('src', 'typed_query')
  searchUrl.searchParams.set('f', 'live') // Lates tab

  const searchQuery = args.symbol
    ? `($${args.symbol} OR ${args.currencyAddress})`
    : args.currencyAddress

  searchUrl.searchParams.set('q', searchQuery)

  return searchUrl
}

export const CurrencyAddressSearchLoupe: React.FC<Props> = ({
  currencyAddress,
  symbol,
  size = 12,
  className,
}) => {
  const { t } = useTranslation()
  const openUnsafeUrlDialog = useAction(unsafeUrlDialogEvent)

  const xHref = createXSearchUrl({ currencyAddress, symbol })

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation()
    e.preventDefault()

    openUnsafeUrlDialog([xHref, 'x'])
  }

  return (
    <Root className={className}>
      <Tooltip
        content={t('currency.search-address', {
          ticker: StringUtil.truncateMiddle(currencyAddress, 5, 4, '…'),
        })}
      >
        <a
          onClick={handleClick}
          href={xHref.toString()}
          target="_blank"
          rel="noopener noreferrer"
        >
          <SearchLoupeIcon size={size} />
        </a>
      </Tooltip>
    </Root>
  )
}

const Root = styled.div`
  a {
    display: grid;
    pointer-events: auto;
    color: var(--text-8);
  }
`
